// extracted by mini-css-extract-plugin
export default {"list":"IcoMo","item":"BYQAK","link":"wYBwh"};